import { useState } from "react";
import { LinkIcon, PorjectBgInfo, Github } from "../../../utils";

const Project = ({ project, selected }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  return (
    <div className={`desktop_slider_item ${selected ? "active" : ""}`}>
      <img
        className="selected_image"
        src={project.images[selectedImage]}
        alt={project.title}
      />
      <div
        className="info"
        style={{ backgroundImage: `url(${PorjectBgInfo})` }}
      >
        <h3 className="project_name">{project.title}</h3>
        <div className="screenshots">
          {project.images.map((image, index) => (
            <img
              className={`${selectedImage === index ? "selected" : ""}`}
              key={index}
              src={image}
              alt={`${project.title} img-${index + 1}`}
              onClick={() => setSelectedImage(index)}
            />
          ))}
        </div>
        <div className="project_info_bottom">
          <div className="tools">
            {project.tools.map((tool, index) => (
              <div key={index} className="tool">
                {tool}
              </div>
            ))}
          </div>
          <div className="links">
            <a href={project.project_full_images} target="_blank">Project images {LinkIcon}</a>
            <a className="github_link" href={project.project_link} target="_blank">{Github}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
